import {PlayerModel} from "../../../models/api/codegen/code";
import {createReducer} from "typesafe-actions";
import {
    getPlayerInfoAsync,
    saveCoupon,
    SET_ACCOUNTS_LOADED,
    SET_AUTHENTICATED,
    SET_AUTHENTICATED_LOADED,
    SET_HAS_ACCOUNTS,
    SET_IDENTIFIED,
    SET_IDENTIFIED_LOADED,
    SET_SPORT_CHL_IN_RESULTS,
    SET_TOKEN
} from '../actions';

export const playerInfo = createReducer({} as PlayerModel)
    .handleAction(getPlayerInfoAsync.success, (state, action) => action.payload)
    .handleAction(saveCoupon.success, (state, action) => action.payload);

export const playerIsFound = createReducer(false)
    .handleAction(getPlayerInfoAsync.success, (state, action) => true)
    .handleAction(getPlayerInfoAsync.failure, (state, action) => false);

export const playerRequestCompleted = createReducer(false)
    .handleAction(getPlayerInfoAsync.request, () => false)
    .handleAction(getPlayerInfoAsync.success, () => true)
    .handleAction(getPlayerInfoAsync.failure, () => true)
    .handleAction(getPlayerInfoAsync.cancel, () => true)

export const playerToken = createReducer("").handleAction(SET_TOKEN, (state, action) => action.payload);

export const playerIdentified = createReducer(false).handleAction(SET_IDENTIFIED, (state, action) => action.payload);

export const playerIdentifiedLoaded = createReducer(false).handleAction(SET_IDENTIFIED_LOADED, (state, action) => action.payload);

export const playerHasAccounts = createReducer(false).handleAction(SET_HAS_ACCOUNTS, (state, action) => action.payload);

export const playerAccountsLoaded = createReducer(false).handleAction(SET_ACCOUNTS_LOADED, (state, action) => action.payload);

export const playerAuthenticated = createReducer(false).handleAction(SET_AUTHENTICATED, (state, action) => action.payload);

export const playerAuthenticatedLoaded = createReducer(false).handleAction(SET_AUTHENTICATED_LOADED, (state, action) => action.payload);

export const sportAndChlInResults = createReducer({sport: true, chesslive: true})
    .handleAction(SET_SPORT_CHL_IN_RESULTS, (state, action) => action.payload)